/**
 * Workshop-type helpers (frontend).
 *
 * INDEPENDENT workshops don't see supplier identity, see the relabelled
 * status namespace, and don't chat with suppliers. PRIVATE workshops see
 * everything. Admins always see everything.
 */
import { UserRole, WorkshopType } from '../types';

interface UserLike {
  role?: UserRole | string;
  workshopType?: WorkshopType | null;
}

export function isIndependentWorkshop(user: UserLike | null | undefined): boolean {
  if (!user) return false;
  return user.role === UserRole.WORKSHOP && user.workshopType === 'INDEPENDENT';
}
